import React from "react";
import Button from "@material-ui/core/Button";
import { observer } from "mobx-react";
import { FaTrash } from "react-icons/fa";

function EventsColumnRenderer(props) {
  return (
    <div
      class="visible-on-hover"
      onClick={async () => {
        try {
          if (props.store.isSubsheet && props.store.parentListId) {
            const parentListContainerStore = window.appStore.getCurrentListContainerStore(props.store.parentListId);
            const hasEditPermissions = parentListContainerStore?.permissions?.canEdit(props.store.parentColumnId, props.store.parentRow);
            if (hasEditPermissions && !hasEditPermissions[0]) {
              window.appStore.notificationStore.showNotification(
                "You don't have permission to delete this row",
                "caution"
              );
              return;
            }
          }
          await window.appStore.notificationStore.confirm({
            description: <>This will delete the selected rows</>,
          });
          props.store.deleteAction(props);
          props.store.isSubsheetRecordsDeleted = true;
        } catch (e) {
          console.log(e);
        }
      }}
    >
      <FaTrash size={15} />
    </div>
  );
}

export default observer(EventsColumnRenderer);
